import "core-js/modules/es.object.assign.js";
import "core-js/modules/es.parse-int.js";
import "core-js/modules/es.promise.js";
import "core-js/modules/es.regexp.to-string.js";
var __awaiter = this && this.__awaiter || function (thisArg, _arguments, P, generator) {
  function adopt(value) {
    return value instanceof P ? value : new P(function (resolve) {
      resolve(value);
    });
  }
  return new (P || (P = Promise))(function (resolve, reject) {
    function fulfilled(value) {
      try {
        step(generator.next(value));
      } catch (e) {
        reject(e);
      }
    }
    function rejected(value) {
      try {
        step(generator["throw"](value));
      } catch (e) {
        reject(e);
      }
    }
    function step(result) {
      result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected);
    }
    step((generator = generator.apply(thisArg, _arguments || [])).next());
  });
};
//@ts-ignore
import { cleanASCII, formatAddress } from "@utils/StringUtils";
//@ts-ignore
import { getPlacesDetails, guessPlace } from "@services/geographyAPI";
export var googlePlaceConverter = (gPlace, address) => __awaiter(void 0, void 0, void 0, function* () {
  var place = {};
  for (var i = 0; i < gPlace["address_components"].length; i++) {
    if (gPlace["address_components"][i].types.indexOf("administrative_area_level_3") !== -1) {
      place.city = gPlace["address_components"][i].long_name;
    } else if (gPlace["address_components"][i].types.indexOf("locality") !== -1) {
      place.locality = gPlace["address_components"][i].long_name;
    } else if (gPlace["address_components"][i].types.indexOf("route") !== -1) {
      place.streetName = gPlace["address_components"][i].long_name;
    } else if (gPlace["address_components"][i].types.indexOf("street_number") !== -1) {
      place.streetNumber = gPlace["address_components"][i].long_name;
    } else if (gPlace["address_components"][i].types.indexOf("postal_code") !== -1) {
      place.zip = gPlace["address_components"][i].long_name;
    }
  }
  place.latitude = gPlace["geometry"].location.lat;
  place.longitude = gPlace["geometry"].location.lng;
  place.address = cleanASCII(address);
  if (typeof place.streetNumber === "undefined") place.streetNumber = null;
  var res = yield guessPlace(place.latitude, place.longitude);
  delete res.city;
  delete res.locality;
  res = Object.assign(Object.assign({}, res), place);
  /* FIX FOR GOOGLE AUTOCOMPLETE MISSING STREET NUMBER */
  if (!res.streetNumber) {
    var term = parseInt(res.address.split(",")[1]);
    var zip = parseInt(res.zip);
    if (term && term !== zip) res.streetNumber = term.toString();
  }
  return res;
});
export var getPlaceFromGAutocomplete = (placeId, label) => __awaiter(void 0, void 0, void 0, function* () {
  var gPlaceDetails = yield getPlacesDetails(placeId);
  var place = yield googlePlaceConverter(gPlaceDetails, label);
  var address = place.streetName ? formatAddress(place.streetName, place.streetNumber || "", place.cityName) : place.address;
  return {
    place,
    address
  };
});